// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1Bsri","title":"Images45_title__6Xg1I","images":"Images45_images__11z5k"};